import React from 'react';
import { Components } from './styled';
import { SelectChangeEvent } from '@mui/material/Select';
import { styles } from '../ProjectSelect/styled';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-angle-down.svg';
import { ReactComponent as ClearIcon } from '../../../assets/icons/icon-close.svg';

const ProjectMultipleSelect = ({
  value,
  onChangeSelectedItem,
  onClearValue,
  name,
  errorMessages,
  disabled,
  placeholder,
  processShownLabel,
  children,
}: {
  value: string[] | undefined;
  onChangeSelectedItem: (e: SelectChangeEvent<string | undefined>) => void;
  onClearValue?: () => void;
  name?: string;
  errorMessages?: string | string[];
  placeholder?: string;
  disabled?: boolean;
  processShownLabel?: (value: any) => any;
  children: React.ReactNode;
}) => {
  const _onChangeSelectedItem = (e: SelectChangeEvent<unknown>) => {
    onChangeSelectedItem?.(e as SelectChangeEvent<string | undefined>);
  };

  const defaultProcessShownLabel = (value: string | undefined) => value;

  const _onClearValue = () => {
    onClearValue?.();
  };

  return (
    <Components.Container>
      <Components.Select
        multiple
        value={value || []}
        {...(name && { name })}
        IconComponent={ArrowDownIcon}
        onChange={_onChangeSelectedItem}
        renderValue={(selected) => (
          <Components.ItemsWrapper>
            {(selected as string[]).map((value) => (
              <Components.Item key={value}>
                {processShownLabel ? processShownLabel(value) : defaultProcessShownLabel(value)}
              </Components.Item>
            ))}
          </Components.ItemsWrapper>
        )}
        {...(onClearValue &&
          value?.length && {
            endAdornment: (
              <Components.ClearButton onClick={_onClearValue}>
                <ClearIcon width={12} height={12} />
              </Components.ClearButton>
            ),
          })}
        disabled={disabled}
        MenuProps={{ sx: styles.SelectMenu as any }}>
        {children}
      </Components.Select>
    </Components.Container>
  );
};

export default ProjectMultipleSelect;
